
/**
 * https://app.clickup.com/30373227/v/dc/wyxbb-16070/wyxbb-16110
 */
export interface Metadata {
	/** nome della CODA */
	serviceCode?: string
	/** key del VALUE */
	name?: string
	/** alias per normalizzare i nomi dei metadata  */
	alias?: string
	/** descrizione con parentesi quadre */
	description?: string

	/** tipo del metadata */
	type?: META_TYPE
	/** come deve essere visualizzato */
	format?: string
	/** indica se il metadata è di sola lettura */
	readOnly?:boolean			

	/** unità di misura */
	um?: string
	/** valore minimo */
	min?: number
	/** valore massimo */
	max?: number

	// ???
	target?: string
	// ???
	group?: string
	/** indica se il dato deve essere "graficato" */
	graph?: boolean
	/** indica se il dato è un parametro gestito sul plan di little root */
	recipe?: boolean

	/** [INTERNAL] indica che il metadata è temporaneo */
	_tmp?: boolean
}

export function isEqual(m1: Metadata, m2: Metadata): boolean {
	return m1.serviceCode == m2.serviceCode && m1.name == m2.name
}

export enum META_TYPE {
	BOOLEAN = "boolean",
	INTEGER = "integer",
	REAL = "real",
}
